require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-online-and-mobile-banking.json") })
        }
      }, "path---es-articles-online-and-mobile-banking");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-online-and-mobile-banking!./.cache/json/es-articles-online-and-mobile-banking.json
// module id = 2227
// module chunks = 231608221292675